import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment_ from 'moment';

const moment = moment_;
let id = 1;

@Component({
  selector: 'wfm-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit, OnChanges {
  @Input() type = 12;

  @Input() interval = 30;

  @Input() disabled: boolean;

  @Input() error: boolean;

  @Input() required: boolean;

  @Input() value: moment_.Moment;
  @Output() valueChange = new EventEmitter<moment_.Moment>();

  @Input() start: moment_.Moment;

  @Input() end: moment_.Moment;

  open: boolean;

  id = 0;

  options: string[] = [];

  input: string;

  get format(): string {
    return (this.type === 12 && 'hh:mm A') || 'HH:mm';
  }

  get placeholder(): string {
    return (this.type === 12 && 'HH:MM AM') || 'HH:MM';
  }

  constructor() {
    this.id = id++;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.interval && changes.interval.currentValue !== changes.interval.previousValue) ||
      (changes.start && changes.start.currentValue !== changes.start.previousValue) ||
      (changes.end && changes.end.currentValue !== changes.end.previousValue) ||
      (changes.value &&
        changes.value.currentValue !== changes.value.previousValue &&
        changes.value.currentValue.isValid())
    ) {
      this.setOptionsList();
    }
  }

  ngOnInit(): void {
    this.setOptionsList();
  }

  private setOptionsList() {
    const today = moment(moment().format('YYYY-MM-DD'));
    const tomorrow = moment(today).add(1, 'day');

    if (this.start) {
      today.hour(this.start.hour()).minute(this.start.minute()).second(this.start.second());
    }

    if (this.end && (!this.start || this.start.isBefore(this.end))) {
      tomorrow.subtract(1, 'day').hour(this.end.hour()).minute(this.end.minute()).second(this.end.second());
    }

    this.options = [];

    while (today.isBefore(tomorrow)) {
      this.options.push(today.format(this.format));

      if (this.value && today.isSame(this.value)) {
        this.input = today.format(this.format);
      }
      today.add(this.interval, 'minute');
    }
  }

  select(option?: string) {
    const value = this.value;

    if (!option) {
      this.input = undefined;
      this.value = undefined;
    } else {
      this.input = option;
      this.value = moment(option, this.format);
    }

    value !== this.value && this.valueChange.emit(this.value);
    this.open = false;
  }
}
